module.exports = __webpack_public_path__ + "static/media/productos_botanas_cacahuate_espanol.49cf5d08.png";